import { AccountClient, GET_PERSONALIZATION_BY_NAME } from '@nile/graphql';

const getColumnOrder = async (name, category, userId) => {
  const response = await AccountClient.query({
    query: GET_PERSONALIZATION_BY_NAME,
    variables: {
      userId: userId,
      category: category,
      name: name
    },
    fetchPolicy: 'network-only'
  });
  return new Promise((resolve) => {
    let columnOrder = [];
    const getPersonalizationByCategoryAndName =
      response?.data?.getPersonalizationByCategoryAndName;
    if (
      getPersonalizationByCategoryAndName &&
      getPersonalizationByCategoryAndName?.value
    ) {
      columnOrder = JSON.parse(getPersonalizationByCategoryAndName?.value);
    }
    resolve(columnOrder);
  });
};

const Queries = { getColumnOrder };

export default Queries;
